/**
 * Shared loan form schema. Used by both API and frontend.
 * API must import with explicit .js extension for Node ESM resolution.
 */
import * as v from "valibot";

export const LOAN_AMOUNT = 1000;

export const LoanFormSchema = v.object({
  employeeFirstName: v.pipe(v.string(), v.trim(), v.nonEmpty("First name is required")),
  employeeLastName: v.pipe(v.string(), v.trim(), v.nonEmpty("Last name is required")),
  employeeEmail: v.pipe(
    v.string(),
    v.trim(),
    v.nonEmpty("Email is required"),
    v.email("Enter a valid email address")
  ),
  employeeNumber: v.pipe(
    v.string(),
    v.trim(),
    v.nonEmpty("Employee # is required"),
    v.maxLength(32, "Employee # is too long")
  ),
  streetAddress: v.pipe(v.string(), v.trim(), v.nonEmpty("Street address is required")),
  city: v.pipe(v.string(), v.trim(), v.nonEmpty("City is required")),
  postalCode: v.pipe(
    v.string(),
    v.trim(),
    v.nonEmpty("Postal code is required"),
    v.transform((s) => s.replace(/\s/g, "").toUpperCase()),
    v.regex(/^[A-Z]\d[A-Z]\d[A-Z]\d$/, "Enter a valid Canadian postal code (e.g. A1A 1A1)"),
    v.transform((s) => `${s.slice(0, 3)} ${s.slice(3)}`)
  ),
  phoneNumber: v.pipe(
    v.string(),
    v.transform((s) => s.replace(/\D/g, "").slice(-10)),
    v.minLength(10, "Enter a valid phone number (at least 10 digits)")
  ),
});

export type LoanFormData = v.InferOutput<typeof LoanFormSchema>;
